import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-lead-details',
  templateUrl: './lead-details.component.html',
  styleUrls: ['./lead-details.component.css']
})
export class LeadDetailsComponent implements OnInit {

  leadDetailsForm: FormGroup;
  perpage: number = 25; leads: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = false; myrole: string;
  pageSizeOptions = [10, 25, 50, 100, 200]; pageIndex: number = 0; leadStatus = []; bds = []; loaded: boolean = false; circles = [];
  treatments = []; search: string = ''; circle: any; dateval: any = ''; dataLoaded: boolean = false;
  submitted: boolean = false; lead_id: string;

  constructor(private formBuilder: FormBuilder, private leadapi: LeadsService, private sharedapi: SharedService, private router: Router, private route: ActivatedRoute) {
    this.leadDetailsForm = this.formBuilder.group({
      'lead_owner': [null, Validators.required],
      'circle': [null, Validators.required],
      'treatment': [null, Validators.required],
      'payment_mode': [null, Validators.required],
      'followup_date': [null],
      'lead_status': [null, Validators.required],
      'age': [null],
      'gender': [null],
      'lead_name': [null, Validators.required],
      'description': [null, Validators.required],
      'lead_mobile': [null, Validators.required],
      'lead_city': [null],
      //'lead_source': [null],
      'keywords': [null],
      'form_lead_source': [null],
      'feedback_description':[null]
    });
  }

  ngOnInit(): void {
    this.sharedapi.getRole().subscribe((item: string) => { this.myrole = item; });
    this.myrole = localStorage.getItem('role');
    this.lead_id = this.route.snapshot.paramMap.get("lead_id");
    this.getbds();
    this.getcircle();
    this.getleadStatus();
    this.getTreatment();
    this.getLeadDetails();

  }


  get f() { return this.leadDetailsForm.controls; }

  async saveLeadDetails() {
    var lead_status_id = this.leadDetailsForm.value.lead_status;
    if(lead_status_id == 1) {  // New Lead = 1
      this.sharedapi.presentToast('Please Change Lead Status');
      return;
    }
    this.submitted = true;
    this.loading = true;
    if (this.leadDetailsForm.invalid) {
      this.loading = false;
      return;
    }
    this.leadDetailsForm.value.id = parseInt(this.lead_id);
    await this.leadapi.saveEditLeadDetails(this.leadDetailsForm.value).subscribe((data: any) => {
      this.submitted = false;
      this.loading = false;
      if (data.status) {
        this.sharedapi.presentToast(data.msg);
        // this.leadDetailsForm.reset();
        // this.router.navigate(['/leads'])
      }
      else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }

  async getcircle() {
    await this.leadapi.getcircles().subscribe((data: any) => {
      if (data.status) {
        this.circles = data.data;
      } else {
        this.circles = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }


  async getbds() {
    await this.leadapi.getbds().subscribe((data: any) => {
      if (data.status) {
        this.bds = data.data;
      } else {
        this.bds = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getTreatment() {
    await this.leadapi.getTreatments().subscribe((data: any) => {
      if (data.status) {
        this.treatments = data.data;
      } else {
        this.treatments = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getleadStatus() {
    await this.leadapi.getLeadStatus().subscribe((data: any) => {
      if (data.status) {
        this.leadStatus = data.data;
      } else {
        this.leadStatus = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getLeadDetails() {
    this.dataLoaded = false;
    await this.leadapi.getLeadUpdateDetail(this.lead_id).subscribe((data: any) => {
      if (data.status) {
        this.dataLoaded = true;
        if (data.data.followup_date) {
          this.dateval = new Date(formatDate(data.data.followup_date * 1000, 'dd MMM, yyyy', 'en-US'))
        }
        this.leadDetailsForm.setValue({
          'lead_name': data.data.lead_name,
          'lead_mobile': 'xxxxxxxxxx',
          //'lead_mobile' : data.data.mobile,
          'lead_city': data.data.city_name,
          'circle': data.data.circle_id,
          'lead_owner': data.data.user_id,
          'treatment': data.data.treatment_id,
          'description': data.data.description,
          'lead_status': data.data.lead_status_id,
          'followup_date': this.dateval,
          'payment_mode': data.data.payment_mode,
          'age': data.data.patient_age,
          'gender': data.data.gender,
          //'lead_source': data.data.gender,
          'keywords': data.data.keywords,
          'form_lead_source': data.data.zoho_lead_source,
          'feedback_description':data.data.feedback_description
        });

      } else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }






}
